export enum Topics {
  DASHBOARD = "Dashboard",
  SYSMESSAGES = 'Sysmessages',
  ATTACHMENT = 'Attachment',
  ISSUES = 'Issues',
  HISTORY = 'History',
  //PERMISSION = 'Permission',
  ISSUE_TYPES = 'IssueTypes',
  PROJECTS = 'Projects',
  COMPANIES = 'Companies',
  PROJECT_SCOPES = 'ProjectScopes',
  ISSUE_COMMENTS = 'IssueComments',
  ENTITY_INTERACTIONS = 'EntityInteractions',
  USERS = "Users",
  WORKFLOWS = "Workflows",
  TAGS = "Tags",
  MILESTONES = "Milestones",
  APPOINTMENT = "Appointment",
  ISSUE_STATES = "IssueStates",
  ISSUE_STATE_WORKFLOWS = "IssueStateWorkflows",
  ISSUE_TYPE_INTERFACES = "IssueTypeInterfaces",
  ISSUE_TYPE_WORKFLOWS = "IssueTypeWorkflows",
  IID_OL_CLIENTE = "IID_OL_Cliente",
  IID_OL_CONTRATTO = "IID_OL_Contratto",
  IID_OL_RIFERIMENTI = "IID_OL_Riferimenti",
  IID_OL_RIFERIMENTI_UI = "IID_OL_RiferimentiUi",
  IID_OL_CONDOMINIO = "IID_OL_Condominio",
  IID_OL_OLO_REQUEST = "IID_OL_OloRequest",
  IID_EP_ASSET = "IID_EP_Asset",
  IID_EP_RICHIESTA_PERMESSO = "IID_EP_Richiesta_Permesso",
  IID_EP_RISPOSTA = "IID_EP_Risposta",
  IID_OL_CHECKLIST = "IID_OL_Checklist",
  IID_OL_SERVIZIO_AGGIUNTIVO = "IID_OL_ServizioAggiuntivo",
  IID_OL_APPARATO = "IID_OL_Apparato",
  IID_OL_APPUNTAMENTO = "IID_OL_Appuntamento",
  IID_OL_ACQUISITO_KO = "IID_OL_AcquisitoKo",
  IID_OL_ACCETTATO_KO = "IID_OL_AccettatoKo",
  IID_OL_ESPLETATO_KO = "IID_OL_EspletatoKo",
  IID_OL_ESPLETATO_OK = "IID_OL_EspletatoOk",
  IID_OL_ANNULLATO = "IID_OL_Annullato",
  IID_OL_COMMUNICATION = "IID_OL_Communication",
  GLOBAL_BATCH_ACTIVITIES = "GLOBAL_BATCH_ACTIVITIES",
  PROJECT_BATCH_ACTIVITIES = "PROJECT_BATCH_ACTIVITIES",
  USER_BATCH_ACTIVITIES = "USER_BATCH_ACTIVITIES",
  IID_OL_SOSPENSIONE = "IID_OL_Sospensione",
  IID_EP_TICKET = "IID_EP_Ticket",
  IID_OL_SOLLECITO = "IID_OL_Sollecito",
  IID_OL_RISPOSTA_SOLLECITO = "IID_OL_RispostaSollecito",
  IID_OL_SUPPORTO = "IID_OL_Supporto",
  IID_OL_RISOLUZIONE = "IID_OL_Risoluzione",
  IID_OL_RISORSA = "IID_OL_Risorsa",
  IID_GENERIC_SUSPENSION = "IID_Generic_Suspension",
  IID_META_INTERFACE = "IID_META_INTERFACE",
  IID_EP_GISFO_SUPPORT = "IID_EP_GisfoSupport",
  IID_GENERIC_KO = "IID_Generic_Ko",
  IID_GR_RESOURCES = "IID_GR_Resources",
  IID_GR_TASKS = "IID_GR_Tasks"
}

export enum IssueTopics {
  IID_OL_CLIENTE = "IID_OL_Cliente",
  IID_OL_CONTRATTO = "IID_OL_Contratto",
  IID_OL_RIFERIMENTI = "IID_OL_Riferimenti",
  IID_OL_RIFERIMENTI_UI = "IID_OL_RiferimentiUi",
  IID_OL_CONDOMINIO = "IID_OL_Condominio",
  IID_OL_CHECKLIST = "IID_OL_Checklist",
  IID_OL_OLO_REQUEST = "IID_OL_OloRequest",
  IID_EP_ASSET = "IID_EP_Asset",
  IID_OL_ACQUISITO_KO = "IID_OL_AcquisitoKo",
  IID_OL_ACCETTATO_KO = "IID_OL_AccettatoKo",
  IID_OL_ESPLETATO_OK = "IID_OL_EspletatoOk",
  IID_OL_ESPLETATO_KO = "IID_OL_EspletatoKo",
  IID_OL_ANNULLATO = "IID_OL_Annullato",
  IID_EP_RICHIESTA_PERMESSO = "IID_EP_Richiesta_Permesso",
  IID_EP_RISPOSTA = "IID_EP_Risposta",
  IID_OL_SERVIZIO_AGGIUNTIVO = "IID_OL_ServizioAggiuntivo",
  IID_OL_APPARATO = "IID_OL_Apparato",
  IID_OL_APPUNTAMENTO = "IID_OL_Appuntamento",
  IID_OL_COMMUNICATION = "IID_OL_Communication",
  IID_OL_SOSPENSIONE = "IID_OL_Sospensione",
  ISSUES = 'Issues',
  ATTACHMENT = 'Attachment',
  ISSUE_COMMENTS = 'IssueComments',
  IID_OL_SOLLECITO = "IID_OL_Sollecito",
  IID_OL_RISPOSTA_SOLLECITO = "IID_OL_RispostaSollecito",
  IID_OL_SUPPORTO = "IID_OL_Supporto",
  IID_OL_RISOLUZIONE = "IID_OL_Risoluzione",
  IID_OL_RISORSA = "IID_OL_Risorsa",
  IID_GENERIC_SUSPENSION = "IID_Generic_Suspension",
  IID_EP_GISFO_SUPPORT = "IID_EP_GisfoSupport",
  IID_GENERIC_KO = "IID_Generic_Ko",
  IID_GR_RESOURCES = "IID_GR_Resources",
  IID_GR_TASKS = "IID_GR_Tasks"
}

export type FilterType = {
  projectId?: string,
  updatedAt?: string,
  external?: boolean,
}
